import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { getSettingEnableNewNAMCommissionModelWebRetailer } from "@faire/retailer-visitor-shared/settings/getSettingEnableNewNAMCommissionModelWebRetailer";
import { RetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { optimizeImageUrl } from "@faire/web--source/common/images/optimizeImages";
import { DEPRECATED_backwardsCompatibleValues } from "@faire/web--source/common/localization/localize";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { EmbeddedLink } from "@faire/web--source/ui/EmbeddedLink";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import supportArticle from "@faire/web-api--source/routes/support/articles/articleId";
import React from "react";
import styled from "styled-components";
var RichContentImage = styled.img.withConfig({
    componentId: "sc-eb57ea3e-0"
})([
    "height:330px;width:446px;",
    "{height:205px;width:250px;}",
    "{height:220px;width:290px;}"
], responsiveMediaQueries.mobile, responsiveMediaQueries.tablet);
var paymentsOnTimeDescription = function(strictLocalize) {
    if (getSettingEnableNewNAMCommissionModelWebRetailer()) {
        return /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "cAlvMJ",
            defaultMessage: [
                {
                    type: 0,
                    value: "We manage payment processing, pay you directly, and cover 60-day payment terms for your eligible customers."
                }
            ]
        });
    }
    if (RetailerStore.get().isEurope) {
        return /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "8ZxKCK",
            defaultMessage: [
                {
                    type: 0,
                    value: "We take care of all credit card and payment processing, and pay you directly for every order. "
                },
                {
                    type: 8,
                    value: "TextLink",
                    children: [
                        {
                            type: 0,
                            value: "How Payouts Work"
                        }
                    ]
                }
            ],
            values: DEPRECATED_backwardsCompatibleValues({
                TextLink: function(chunk) {
                    return /*#__PURE__*/ _jsx(EmbeddedLink, {
                        linkTo: supportArticle("360040446591"),
                        children: chunk
                    });
                }
            })
        });
    }
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: strictLocalize({
            id: "RHzjne",
            defaultMessage: [
                {
                    type: 0,
                    value: "We take care of payment processing, pay you directly, and cover 60-day payment terms for your customers."
                }
            ]
        })
    });
};
export var getIntros = function(isSSR, strictLocalize) {
    return [
        {
            eventKey: "grow-business",
            header: strictLocalize({
                id: "KZ9cWQ",
                defaultMessage: [
                    {
                        type: 0,
                        value: "New wholesale customers"
                    }
                ]
            }),
            description: strictLocalize({
                id: "1bTcgH",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Boost your business with exposure to hundreds of thousands of verified independent retailers worldwide."
                    }
                ]
            }),
            richContent: /*#__PURE__*/ _jsx(RichContentImage, {
                src: optimizeImageUrl({
                    url: "https://cdn.faire.com/fastly/8a4633a1b6b3f7e5caa2dbda0c4cf89c1fd425ecf230e285713416411630f5fc.png"
                }, isSSR)
            }),
            reverse: false,
            index: 1,
            startTracking: false
        },
        {
            eventKey: "get-payments-on-time",
            header: getSettingEnableNewNAMCommissionModelWebRetailer() ? strictLocalize({
                id: "kTMMpe",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Secure, on-time payments"
                    }
                ]
            }) : strictLocalize({
                id: "JXBa9M",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Secure, on-time payment\u2014guaranteed"
                    }
                ]
            }),
            description: paymentsOnTimeDescription(strictLocalize),
            richContent: /*#__PURE__*/ _jsx(RichContentImage, {
                src: optimizeImageUrl({
                    url: "https://cdn.faire.com/fastly/d9f62dd87b40bfaab32024baf07d1ca7323d56d1a89e64d1555d443d8287ae17.png"
                }, isSSR)
            }),
            reverse: true,
            index: 2,
            startTracking: false
        },
        {
            eventKey: "get-more-sales",
            header: strictLocalize({
                id: "jKm6oK",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Saved time and money"
                    }
                ]
            }),
            description: strictLocalize({
                id: "z7TmTn",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Grow efficiently with easy order management, plus free marketing and customer tools."
                    }
                ]
            }),
            richContent: /*#__PURE__*/ _jsx(RichContentImage, {
                src: optimizeImageUrl({
                    url: "https://cdn.faire.com/fastly/9dadca88996af66e8ffea83bbc4d8cafbbe90a755612f559ff3d06423711cd41.png"
                }, isSSR)
            }),
            reverse: false,
            index: 3,
            startTracking: false
        }
    ];
};
